import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-aae62748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = ["data-bs-target"]
const _hoisted_3 = { class: "left-container" }
const _hoisted_4 = { class: "right-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content-item" }
const _hoisted_7 = { class: "left-container" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "country" }
const _hoisted_11 = ["data-bs-toggle", "data-bs-target", "aria-controls", "onClick"]
const _hoisted_12 = { class: "left-container" }
const _hoisted_13 = {
  key: 0,
  class: "right-container"
}
const _hoisted_14 = ["id"]

import { onMounted, ref, watch, reactive } from 'vue';
  import { Offcanvas } from 'bootstrap';
  import { countryList, currentCountry } from '@/constants';
  import { Menu } from '@/types/menu';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    visible?: boolean,
    menus: Menu[]
  }

  interface Emits {
    (event: 'update:visible', visible: boolean): boolean;
    (event: 'hide'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    menus: null
  },
  emits: ["update:visible", "hide"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:visible', visible: boolean): boolean;
    (event: 'hide'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    visible?: boolean,
    menus: Menu[]
  }

  const { t } = useI18n();
  const  offcanvasRef = ref();
  let offcanvasInstance: Offcanvas;

  
  

  const languageId = 'mobile-menu-language';
  const collapseMap = reactive<{[propName: string]: boolean}>({});

  function handleTriggerCollapse(id: string) {
    collapseMap[id] = !Boolean(collapseMap[id]);
  };

  function checkCollapse(item: Menu) {
    return item.children && item.children.length;
  }

  function close(item?: Menu) {
    if (item && Array.isArray(item.children)) {
      return;
    }
    emits('update:visible', false);
    emits('hide');
  }

  onMounted(() => {
    offcanvasInstance = new Offcanvas(offcanvasRef.value, { keyboard: false });
    offcanvasRef.value.addEventListener('hide.bs.offcanvas', () => {
      close();
    });
    Boolean(props.visible) ? offcanvasInstance.show() : offcanvasInstance.hide();
  });

  watch(() => props.visible, val => {
    Boolean(val) ? offcanvasInstance.show() : offcanvasInstance.hide();
  });

  function handleLanguage(item: any) {
    if (item.link && item.link !== location.origin) {
      location.href = item.link;
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "offcanvasRef",
    ref: offcanvasRef,
    class: "menu-wrapper offcanvas offcanvas-end"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(countryList).length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "title-box border-bottom",
            "data-bs-toggle": "collapse",
            "data-bs-target": `#${languageId}`,
            "aria-expanded": "false",
            "aria-controls": languageId,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTriggerCollapse(languageId)))
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Language')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _unref(currentCountry).icon,
                class: "flag"
              }, null, 8, _hoisted_5),
              _createElementVNode("img", {
                src: _imports_0,
                class: _normalizeClass(["arrow", { rotate: _unref(collapseMap)[languageId] }])
              }, null, 2)
            ])
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: languageId,
        class: "content-box collapse"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('Asia Pacific')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "content-item",
            onClick: ($event: any) => (handleLanguage(item))
          }, [
            _createElementVNode("img", {
              src: item.icon,
              class: "flag"
            }, null, 8, _hoisted_9),
            _createElementVNode("span", _hoisted_10, _toDisplayString(item.text), 1)
          ], 8, _hoisted_8))
        }), 128))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menus, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "item"
      }, [
        _createElementVNode("div", {
          class: "title-box",
          "aria-expanded": "false",
          "data-bs-toggle": checkCollapse(item) ? 'collapse' : '',
          "data-bs-target": `#${item.id}`,
          "aria-controls": item.id,
          onClick: ($event: any) => (handleTriggerCollapse(item.id))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: item.to || '',
              class: "router-link",
              onClick: ($event: any) => (close(item))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "onClick"])
          ]),
          (checkCollapse(item))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: _normalizeClass(["arrow", { rotate: _unref(collapseMap)[item.id] }])
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_11),
        (checkCollapse(item))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: item.id,
              class: "content-box collapse"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (menu, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "content-item"
                }, [
                  _createVNode(_component_router_link, {
                    to: menu.to,
                    class: "router-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(menu.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ], 8, _hoisted_14))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 512))
}
}

})